import { useEffect, useRef } from "react";
import {
  RevenueIntelligenceChatScopeAction,
  useRevenueIntelligenceChat,
} from "./RevenueIntelligenceChatContext";

export function RevenueIntelligenceChatScopeRegistration({
  actions,
  scopeKey,
}: {
  actions: RevenueIntelligenceChatScopeAction[];
  scopeKey: string;
}) {
  const {
    registerScopeActions,
    unregisterScopeActions,
  } = useRevenueIntelligenceChat();
  const actionsRef = useRef(actions);
  actionsRef.current = actions;
  const actionsKey = JSON.stringify(actions.map(action => ({
    actionId: action.actionId,
    aliases: action.aliases,
    field: action.field,
    label: action.label,
    values: action.values,
  })));

  useEffect(() => {
    registerScopeActions(
      scopeKey,
      actionsRef.current.map(action => ({
        actionId: action.actionId,
        aliases: action.aliases,
        field: action.field,
        label: action.label,
        values: action.values,
        apply: () => {
          actionsRef.current
            .find(current => current.actionId === action.actionId)
            ?.apply();
        },
        resolve: action.resolve
          ? actions => actionsRef.current
              .find(current => current.actionId === action.actionId)
              ?.resolve?.(actions) ?? []
          : undefined,
      })),
    );
    return () => unregisterScopeActions(scopeKey);
  }, [actionsKey, registerScopeActions, scopeKey, unregisterScopeActions]);

  return null;
}
